export default {"src":"/_next/static/media/mysuru-warrious.a73ddbe4.svg","height":130,"width":155,"blurWidth":0,"blurHeight":0};